/**
 * Composant bouton retour unifié.
 * Retourne un <a class="back-btn"> ou null si backRoute est absent.
 */

import { el } from '../js/utils.js';
import { t } from '../js/i18n.js';

export function createBackButton(backRoute) {
  if (!backRoute) return null;
  return el(
    'a',
    { class: 'back-btn', href: backRoute.url },
    `← ${t(backRoute.labelKey, backRoute.labelParams)}`
  );
}
